var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArgenCoIconPlusRgb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 425.2 425.2",
    style: {
      enableBackground: "new 0 0 425.2 425.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0plus{fill:#145459;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0plus",
    d: "M425.2,212.6c0-58.5-57.5-71.5-138.2-74.4C284.1,57.5,271.1,0,212.6,0s-71.5,57.5-74.4,138.2 C57.5,141.1,0,154.1,0,212.6c0,58.5,57.5,71.5,138.2,74.4c2.9,80.7,15.9,138.2,74.4,138.2S284.1,367.7,287,287 C367.7,284.1,425.2,271.1,425.2,212.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgenCoIconPlusRgb);
export default __webpack_public_path__ + "static/media/ArgenCo_icon_plus_rgb.c8e52fe1bc9ac0d57190a4c45eeadb0b.svg";
export { ForwardRef as ReactComponent };